import { PaperConfig } from './types';

/**
 * English Language Paper 1 (1EN0/01)
 * - Section A: Reading (fiction text) - Q1-Q4
 * - Section B: Imaginative Writing - Q5 (choice of two)
 */
export const englishLanguagePaper1Config: PaperConfig = {
  paperCode: '1EN0/01',
  displayName: 'English Language Paper 1',
  subject: 'English Language',
  paperNumber: 'Paper 1',
  totalTimeMinutes: 105, // 1 hour 45 minutes

  sections: [
    {
      id: 'A',
      title: 'SECTION A',
      subtitle: 'Reading',
      instructions: [
        'Read the text in the Reading Text Insert provided and answer ALL questions.',
        'You should spend about 1 hour on this section.',
        'Write your answers in the spaces provided.',
      ],
      categories: ['Q1', 'Q2', 'Q3', 'Q4'],
      timeGuidance: 60,
    },
    {
      id: 'B',
      title: 'SECTION B',
      subtitle: 'Imaginative Writing',
      instructions: [
        'Answer ONE question. You should spend about 45 minutes on this section.',
        'Write your answer in the space provided.',
      ],
      categories: ['SectionB'],
      hasQuestionChoice: true,
      timeGuidance: 45,
    },
  ],

  readingInsert: {
    textCount: 1,
    buttonLabels: ['View Reading Text'],
  },
};
